import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ui-step',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './step.component.html',
  styleUrl: './step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepComponent {
  /**
   * The step number to be displayed in the stepper.
   */
  @Input() stepNumber = 1;
  /**
   * The title of the step to be displayed in the stepper.
   */
  @Input() stepTitle = '';
  /**
   * Whether the step is active or not.
   */
  @Input() isActive = false;

  /**
   * is the last step in the stepper
   */
  @Input() isLastStep = false;

  /**
   * Total number of steps, used for the visually hidden "Step x of y" text.
   */
  @Input() totalSteps = 0;
}
